import React, { useState, useEffect } from 'react';
import { TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';

import Modal from 'components/Tvendo/Common/ModalBase';
import { wsGetAll } from 'services/WService';

export default function ModalCompany(props) {
  const company = props.model;

  const [ubigeos, setUbigeos] = useState([]);
  const [selectedUbigeo, setSelectedUbigeo] = useState(null);
  // base_ubigeo_id se manda por dataChanging (el Autocomplete no tiene input nativo con name).
  const [ubigeoData, setUbigeoData] = useState({});

  async function listUbigeos() {
    const res = await wsGetAll('base/ubigeo');
    if (res.success) setUbigeos(res.data);
  }

  useEffect(() => {
    if (company.open) {
      listUbigeos();
      setUbigeoData({});
      setSelectedUbigeo(null);
    }
  }, [company]);

  // Al editar, preselecciona el ubigeo actual cuando ya cargó la lista.
  useEffect(() => {
    if (company.base_ubigeo_id && ubigeos.length) {
      setSelectedUbigeo(ubigeos.find((u) => u.id === company.base_ubigeo_id) || null);
    }
  }, [ubigeos, company.base_ubigeo_id]);

  return (
    <Modal
      title="Empresa"
      model={company}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      entity="base/company"
      dataChanging={ubigeoData}
      setDataChanging={setUbigeoData}
      fullWidth
      maxWidth="sm"
    >
      <TextField
        label="Nombre"
        fullWidth
        name="compnyName"
        margin="normal"
        defaultValue={company.compnyName || ''}
        required
      />
      <TextField
        label="RUC"
        fullWidth
        name="taxIdNum"
        margin="normal"
        defaultValue={company.taxIdNum || ''}
        required
      />
      <TextField
        label="Dirección"
        fullWidth
        name="compnyAddr"
        margin="normal"
        defaultValue={company.compnyAddr || ''}
      />
      <TextField
        label="País"
        fullWidth
        name="country"
        margin="normal"
        defaultValue={company.country || ''}
      />
      <TextField
        label="Registro MTC"
        fullWidth
        name="mtc_registration"
        margin="normal"
        defaultValue={company.mtc_registration || ''}
      />
      <Autocomplete
        options={ubigeos}
        value={selectedUbigeo}
        getOptionLabel={(o) => `${o.U_SYP_DEPA}, ${o.U_SYP_PROV}, ${o.U_SYP_DIST}`}
        getOptionSelected={(o, v) => o.id === v.id}
        onChange={(e, item) => {
          setSelectedUbigeo(item);
          setUbigeoData(item ? { base_ubigeo_id: item.id } : { base_ubigeo_id: null });
        }}
        renderInput={(params) => (
          <TextField {...params} label="Buscar Ubigeo" margin="normal" />
        )}
      />
    </Modal>
  );
}
